export const formatRoomTypeChartData = (bookedBookings, cancelledBookings) => {
  const bookedRoomTypes = bookedBookings.reduce((acc, booking) => {
    booking.rooms.forEach((room) => {
      const roomType = room.room || "Unknown";
      const count = room.numberOfRooms || 1;
      acc[roomType] = (acc[roomType] || 0) + count;
    });
    return acc;
  }, {});
  const cancelledRoomTypes = cancelledBookings.reduce((acc, booking) => {
    booking.rooms.forEach((room) => {
      const roomType = room.room || "Unknown";
      const count = room.numberOfRooms || 1;
      acc[roomType] = (acc[roomType] || 0) + count;
    });
    return acc;
  }, {});

  const allRoomTypes = [
    ...new Set([
      ...Object.keys(bookedRoomTypes),
      ...Object.keys(cancelledRoomTypes),
    ]),
  ];
  const sortedRoomTypes = allRoomTypes.sort((a, b) => {
    const totalA = (bookedRoomTypes[a] || 0) + (cancelledRoomTypes[a] || 0);
    const totalB = (bookedRoomTypes[b] || 0) + (cancelledRoomTypes[b] || 0);
    return totalB - totalA;
  });

  const bookedData = sortedRoomTypes.map(
    (roomType) => bookedRoomTypes[roomType] || 0
  );
  const cancelledData = sortedRoomTypes.map(
    (roomType) => cancelledRoomTypes[roomType] || 0
  );

  return {
    labels: sortedRoomTypes,
    datasets: [
      {
        label: "Booked",
        data: bookedData,
        backgroundColor: "rgba(0, 128, 128, 0.6)",
        borderColor: "rgba(0, 128, 128, 1)",
        borderWidth: 1,
      },
      {
        label: "Cancelled",
        data: cancelledData,
        backgroundColor: "rgba(0, 102, 204, 0.6)",
        borderColor: "rgba(0, 102, 204, 1)",
        borderWidth: 1,
      },
    ],
  };
};
